<script>
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"
import frLocale from "@fullcalendar/core/locales/fr"
import ToastHandler from "../../activity_management/absences/mixins/ToastHandler.vue"

export default {
    name: "FullCalendarHandler",

    mixins: [ToastHandler],

    data() {
        return {
            month: null,
            year: null,
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    interactionPlugin,
                ],
                aspectRatio: 2,
                locale: frLocale,
                timeZone: 'UTC',
                initialView: 'dayGridMonth',
                weekends: true,
                headerToolbar: {
                    right: 'prev,next',
                    center: '',
                    left: 'title'
                },
                themeSystem: 'bootstrap',
                editable: true,
                events: [],
                eventOrder: (a, b) => {
                    if (a.extendedProps.priority !== b.extendedProps.priority) {
                        return a.extendedProps.priority - b.extendedProps.priority;
                    }
                    return a.title.localeCompare(b.title);
                },
                eventContent: this.renderEventContent,
                eventDrop: this.handleEventDrop,
                eventClick: this.handleEventClick,
                datesSet: this.handleDatesSet
            },
            form: {
                delta: 0
            },
        }
    },

    methods: {
        handleDatesSet(info) {
            const startDate = new Date(info.view.currentStart)
            const newYear = startDate.getFullYear()
            const newMonth = startDate.getMonth() + 1

            // Avoid unnecessary updates if the year and month are the same
            if (this.year !== newYear || this.month !== newMonth) {
                this.year = newYear
                this.month = newMonth

                this.getItems()
            }
        },

        renderEventContent(arg) {
            // Create a container div for the event content
            let container = document.createElement('div');

            // Create the icon element
            if (arg.event.extendedProps.icon) {
                let icon = document.createElement('i')
                icon.className = arg.event.extendedProps.icon // Access the custom `icon` property
                container.appendChild(icon) // Append the icon to the container
            }

            // Create the title element
            let title = document.createElement('span')
            title.innerText = arg.event.title
            container.appendChild(title) // Append the title to the container

            // Create the description element (optional, based on extendedProps)
            // if (arg.event.extendedProps.description) {
            //     let tooltip = document.createElement('div')
            //     tooltip.className = 'my-tooltip'
            //     tooltip.innerText = arg.event.extendedProps.description
            //     container.appendChild(tooltip)
            // }

            return {domNodes: [container]} // Return the container as a single node
        },

        async handleEventDrop(info) {
            this.form.delta = info.delta.days
            let element = info.event.extendedProps.element
            switch (element.type) {
                case 'clientDeadlines':
                    await this.moveClientDeadline(element.id)
                    break
                case 'todos':
                    await this.moveTodo(element.id)
                    break
                default:
                    break
            }
            await this.getItems()
        },

        async handleEventClick(info) {
            info.jsEvent.preventDefault();
            let element = info.event.extendedProps.element
            switch (element.type) {
                case 'clientDeadlines':
                    await this.toggleClientDeadline(element.id)
                    break
                case 'todos':
                    window.location = info.event.url
                    break
                case 'plannedTasks':
                    window.location = info.event.url
                    break
                case 'links':
                    this.handleClick(element.day)
                    break
                default:
                    break
            }
        },

        async toggleClientDeadline(elementId) {
            try {
                await axios.put(`/clientDeadlines/${elementId}/toggle`)
            } catch (e) {
                //
            }
            await this.getItems()
        },

        async moveClientDeadline(id) {
            this.showRecordingToast()
            try {
                let response = await axios.put(
                    `/clientDeadlines/${id}/move`,
                    this.form
                )
                this.handleRecordingResponse(response.data.meta)
            } catch (e) {
                //
            }
        },

        async moveTodo(id) {
            this.showRecordingToast()
            try {
                let response = await axios.put(
                    `/todo/${id}/move`,
                    this.form
                )
                this.handleRecordingResponse(response.data.meta)
            } catch (e) {
                //
            }
        },
    }
}
</script>
